import { render, staticRenderFns } from "./BookingExpired.vue?vue&type=template&id=c6ffd776&scoped=true"
import script from "./BookingExpired.vue?vue&type=script&lang=ts"
export * from "./BookingExpired.vue?vue&type=script&lang=ts"
import style0 from "./BookingExpired.vue?vue&type=style&index=0&id=c6ffd776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ffd776",
  null
  
)

export default component.exports